// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import TitleUnderlined from './TitleUnderlined';
import Explication from '../explication/Explication';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  content: PropTypes.object.isRequired,
};

const defaultProps = {};

const contextTypes = {
  t: PropTypes.func,
};


function Banner(props) {
  const {
    content: {
      bannerTitle,
      presentation,
      explications,
    },
  } = props;
  return (
    <div className="banner">
      { bannerTitle && presentation &&
        <TitleUnderlined title={bannerTitle} subtitle={presentation} />
      }
      {explications &&
        <div className="banner__explications">
          {Object.keys(explications).map((key) =>
            <Explication key={`explication_${key}`} type={key} content={explications[key]} />,
          )}
        </div>
      }
    </div>
  );
}

Banner.propTypes = propTypes;
Banner.defaultProps = defaultProps;
Banner.contextTypes = contextTypes;

export default Banner;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/banner/Banner.js